import React, { useEffect, useMemo, useRef, useState } from "react";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import "../../appointment/appointment-create-form.scss";
import { Toast } from "../../../utils/SwalUti";
import { checkDobUnit, convertDobToAgeYearMonth, convertAgeToDobYearMonth } from "../../../utils/common-funtions/common";
import SelectWithLocalSearch from "../../common/updated-input/select-with-local-search/select-with-local-search";
import { get, post, put } from "../../../utils/fetchAPI";
import CreatableSearchSelect from "../../common/updated-input/createble-search-select/creatable-search-select";
import { getOccupations, createOccupation } from "../../../service/api/occupation-api";
import { Select } from "antd";


const PatientDemography = ({ visitDetails, patientId, patientDetails, updateState, refresh, updateVisit }) => {
    const [info, setInfo] = useState({});
    const [updatedInfo, setUpdatedInfo] = useState({})
    const [patientInfo, setPatientInfo] = useState(false);
    const lastSavedRef = useRef("");
    const [referral, setReferral] = useState("")
    const timeoutIdRef = useRef(null)
    const [referralList, setReferralList] = useState([])
    const [occupationList, setOccupationList] = useState([])
    const [seletedDistrict, setSelectedDistrict] = useState({})
    const [age, setAge] = useState({
        age: 0,
        ageUnit: "year(s)"
    })
    let { districtList } = useSelector(
        (state) => state.visit
    );

    const maritalStatusOptions = [
        {
            id: 1,
            name: "Married",
            value: "married"
        },
        {
            id: 2,
            name: "Unmarried",
            value: "unmarried"
        },
    ]

    useEffect(() => {
        if (visitDetails?.patient || patientId) {
            if (patientDetails)
                setPatientInfo(patientDetails)
            else
                getPatientDetails(visitDetails?.patient || patientId)
        }
        if (patientDetails) {
            setPatientInfo(patientDetails)
        }
        if (visitDetails?.patient) setReferral(visitDetails?.referredBy)
        if (visitDetails?.doctor) getRefferalList(visitDetails?.doctor)
        getOccupationList(visitDetails?.doctor)

    }, [visitDetails?.patient, patientId, patientDetails])


    function getPatientDetails(patientId) {
        get(`/patient/${patientId}`)
            .then((res) => {
                if (res?.status === 200) {
                    setPatientInfo(res.data)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    //
    // const refresh = () => {
    //     dispatch(getPatientDetails(patientId));
    // }


    useMemo(() => {
        if (patientInfo?.dob) {
            let currentAge = convertDobToAgeYearMonth(patientInfo?.dob, checkDobUnit(patientInfo?.dob)) || ""
            let splitCurrentAge = currentAge?.split(" ")
            setAge({
                age: splitCurrentAge[0], ageUnit: splitCurrentAge[1]
            })
            setInfo(patientInfo)
        }
        if (patientInfo?.district?._id) {
            setSelectedDistrict({ label: patientInfo?.district?.name, value: patientInfo?.district?._id })
        }
    }, [patientInfo])

    // Auto-save: posts the accumulated diff. Text fields call this on blur;
    // discrete controls (radios/selects) call it right after their change.
    const savePatient = async (payload) => {
        const cleaned = { ...(payload || {}) };
        // required fields — never blank them out from a blur
        if ('name' in cleaned && !cleaned.name?.trim()) delete cleaned.name;
        if ('dob' in cleaned && !cleaned.dob) delete cleaned.dob;
        if (!info?.patientId || Object.keys(cleaned).length === 0) return;
        const serialized = JSON.stringify(cleaned);
        if (serialized === lastSavedRef.current) return; // nothing new since last save
        await post(`/patient/update/${info?.patientId}`, cleaned)
            .then((res) => {
                if (res.status === 200) {
                    lastSavedRef.current = serialized;
                    if (cleaned.name || cleaned.gender || cleaned.dob || cleaned.phone) appointmentUpdate(cleaned)
                    updateState(res?.data)
                    Toast.fire({
                        icon: '',
                        title: "Patient updated successfully"
                    })
                }
            })
            .catch((error) => { });
    };

    const saveOnBlur = () => savePatient(updatedInfo);

    // change + save in one step, for controls where picking a value ends the edit
    const setAndSave = (key, value) => {
        const payload = { ...updatedInfo, [key]: value };
        setInfo({ ...info, [key]: value });
        setUpdatedInfo(payload);
        savePatient(payload);
    };


    const appointmentUpdate = async (values) => {
        let payload = {}
        if (values?.name) payload.patientName = values?.name
        if (values?.gender) payload.patientGender = values?.gender
        if (values?.dob) payload.patientDob = values?.dob
        if (values?.phone) payload.patientPhone = values?.phone
        if (referral) {
            payload.referredBy = referral
        }
        await handleReferralUpdate(payload)
        if (!visitDetails?.appointment) return;
        await put(`appointment/update/${visitDetails?.appointment}`, payload)
            .then((res) => {
                if (res.status === 200) {
                }
            })
            .catch((error) => {

            });
    };

    const handleReferralUpdate = async (payload) => {
        if (!visitDetails?._id) return;
        await put(`/visit/${visitDetails?._id}`, payload)
            .then((res) => {
                if (res.status === 200) {
                    updateVisit(res?.data)
                    setReferral(res?.data?.referredBy)
                }
            })
            .catch((e) => { })
            .finally(() => { })
    }


    const setInfoFun = (key, value) => {
        let temp = { ...info };
        setInfo({ ...temp, [key]: value });
        setUpdatedInfo({ ...updatedInfo, [key]: value })
    };

    // Returns the updated diff so discrete controls (age unit) can save it directly.
    const setDobAgeInfoFun = (key, value) => {
        let temp = { ...info };
        let nextUpdated;
        if (key == "dob") {
            let currentAge = convertDobToAgeYearMonth(value, age?.ageUnit)
            setInfo({ ...temp, dob: value });
            nextUpdated = { ...updatedInfo, dob: value }
            let splitCurrentAge = currentAge?.split(" ")
            setAge({
                age: splitCurrentAge[0], ageUnit: splitCurrentAge[1]
            })
        } else if (key == "ageUnit") {
            setInfo({ ...temp, dob: convertAgeToDobYearMonth(age?.age, value), age: age?.age + " " + value });
            nextUpdated = { ...updatedInfo, dob: convertAgeToDobYearMonth(age?.age, value) }
            setAge({ ...age, ageUnit: value })
        } else {
            setInfo({ ...temp, dob: convertAgeToDobYearMonth(value, age?.ageUnit), age: value + " " + age?.ageUnit });
            nextUpdated = { ...updatedInfo, dob: convertAgeToDobYearMonth(value, age?.ageUnit) }
            setAge({ ...age, age: value })
        }
        setUpdatedInfo(nextUpdated)
        return nextUpdated
    };





    const setRefferalListFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { (getRefferalList(visitDetails?.doctor, event?.target?.value)) }, 800)

    }
    const handleAddToPrescription = (value) => {
        const next = referral + (referral?.length >= 2 ? "\n" : "") + value?.details
        setReferral(next)
        handleReferralUpdate({ referredBy: next })
    }
    const handleCreateReferral = (value) => {
        const next = referral + (referral?.length >= 2 ? "\n" : "") + value
        setReferral(next)
        handleReferralUpdate({ referredBy: next })
        addReferral(visitDetails?.doctor, value)
    }

    const getRefferalList = async (doctorId = visitDetails?.doctor, search = "") => {
        await get(`/doctor/referral/${doctorId}?search=${search}`)
            .then((res) => {
                if (res?.status == 200) {
                    setReferralList(res?.data)
                }
            })
            .catch((error) => {
                // setIsSubmitting(false);
            });
    }

    // Seeded defaults + this doctor's own additions.
    const getOccupationList = async (doctorId = visitDetails?.doctor) => {
        await getOccupations(doctorId)
            .then((res) => {
                if (res?.status == 200) setOccupationList(res?.data || [])
            })
            .catch(() => { })
    }

    // Typed occupation matched no suggestion — save it against this doctor.
    const handleCreateOccupation = async (name) => {
        setAndSave("profession", name)
        await createOccupation({ doctorId: visitDetails?.doctor, name })
            .then((res) => {
                if (res?.status == 200) getOccupationList()
            })
            .catch(() => { })
    }

    // Older patients stored the slug ("garments_worker"); show the label for those too.
    const occupationLabel = useMemo(() => {
        if (!info?.profession) return ""
        const match = occupationList.find(
            (option) => option?.value === info.profession || option?.name === info.profession
        )
        return match?.name || info.profession
    }, [info?.profession, occupationList])

    const addReferral = async (doctorId, details) => {
        await post(`/doctor/referral/create`, {
            "doctorId": doctorId,
            "details": details
        })
            .then((res) => {
                if (res?.status == 200) {
                    getRefferalList()
                }
            })
            .catch((error) => {
                // setIsSubmitting(false);
            });;
    }

    const onChange = (value, option) => {
        setSelectedDistrict({ label: option?.label, value: value })
        const payload = { ...updatedInfo, district: value }
        setUpdatedInfo(payload)
        savePatient(payload)
    };


    return (
        <Formik
            initialValues={{
                name: "",
                phone: "",
                email: "",
                gender: "",
                dob: "",
                bloodGroup: "",
                maritalStatus: ""
            }}
            onSubmit={() => { }}
        >
            {() => (
                <div className="appointment-create-form-section appointment-create-form pb-0 px-3 px-md-4">
                    <Form
                        action=""
                        id=""
                        className="custom-form input-section appointment-create-form__form position-relative"
                        encType="multipart/form-data"
                    >
                        <div className="row mt-0 pt-0 g-2">
                            <div className="col-12 appointment-create-form__panel">
                                <h3 className="appointment-create-form__section-title">Patient</h3>
                                <div className="col-12 appointment-create-form__row">
                                    <label htmlFor="pd-name" className="appointment-create-form__label">
                                        Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        required
                                        className="form-control input appointment-create-form__control"
                                        autoComplete="off"
                                        type="text"
                                        id="pd-name"
                                        name="name"
                                        value={info?.name || ""}
                                        placeholder="Enter name"
                                        onChange={(e) => setInfoFun("name", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                                <div className="col-12 appointment-create-form__row">
                                    <label htmlFor="pd-patient-id" className="appointment-create-form__label">
                                        Patient ID
                                    </label>
                                    <input
                                        className="form-control input appointment-create-form__control"
                                        autoComplete="off"
                                        type="text"
                                        id="pd-patient-id"
                                        name="patientId"
                                        disabled
                                        placeholder="—"
                                        value={info?.patientId || ""}
                                        onChange={(e) => setInfoFun("patientId", e.target.value)}
                                    />
                                </div>
                                <div className="col-12 appointment-create-form__row">
                                    <label htmlFor="pd-phone" className="appointment-create-form__label">
                                        Phone
                                    </label>
                                    <input
                                        className="form-control input appointment-create-form__control"
                                        autoComplete="off"
                                        // pattern="(^(01){1}[3-9]{1}\d{8})$"
                                        type="text"
                                        id="pd-phone"
                                        name="phone"
                                        placeholder="Enter phone number"
                                        value={info.phone || ""}
                                        onChange={(e) => setInfoFun("phone", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                                <div className="col-12 appointment-create-form__row">
                                    <label htmlFor="pd-email" className="appointment-create-form__label">
                                        Email
                                    </label>
                                    <input
                                        className="form-control input appointment-create-form__control"
                                        autoComplete="off"
                                        type="email"
                                        id="pd-email"
                                        name="email"
                                        placeholder="Enter email"
                                        value={info?.email || ""}
                                        onChange={(e) => setInfoFun("email", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--age">
                                    <label htmlFor="pd-age" className="appointment-create-form__label">
                                        Age<span className="text-danger">*</span>
                                    </label>
                                    <div className="appointment-create-form__age-inputs">
                                        <input
                                            id="pd-age"
                                            required
                                            className="form-control input appointment-create-form__control appointment-create-form__control--age"
                                            autoComplete="off"
                                            type="number"
                                            name="age"
                                            placeholder="Age"
                                            value={age?.age || ""}
                                            onChange={(e) => setDobAgeInfoFun("age", e.target.value)}
                                            onBlur={saveOnBlur}
                                        />
                                        <select
                                            className="appointment-create-form__age-unit"
                                            aria-label="Age unit"
                                            onChange={(e) => savePatient(setDobAgeInfoFun("ageUnit", e.target.value))}
                                            value={age?.ageUnit || ""}
                                        >
                                            <option value="year(s)">year(s)</option>
                                            <option value="month(s)">month(s)</option>
                                            <option value="day(s)">day(s)</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--dob">
                                    <label htmlFor="pd-dob" className="appointment-create-form__label">
                                        Date of birth<span className="text-danger">*</span>
                                        <span className="appointment-create-form__hint">dd/mm/yyyy</span>
                                    </label>
                                    <input
                                        required
                                        className="form-control input appointment-create-form__control"
                                        autoComplete="off"
                                        type="date"
                                        id="pd-dob"
                                        name="dob"
                                        value={info?.dob?.slice(0, 10) || ""}
                                        onChange={(e) => setDobAgeInfoFun("dob", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__panel">
                                <h3 className="appointment-create-form__section-title appointment-create-form__section-title--spaced">
                                    Referral &amp; location
                                </h3>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--referral">
                                    <label className="appointment-create-form__label appointment-create-form__label--top">
                                        Referred by
                                    </label>
                                    <div className="appointment-create-form__referral-stack w-100">
                                        <CreatableSearchSelect
                                            options={referralList}
                                            setOptionFun={setRefferalListFun}
                                            handleSubmit={handleAddToPrescription}
                                            handleCreate={handleCreateReferral}
                                        />
                                        <textarea
                                            rows={3}
                                            className="form-control input appointment-create-form__textarea"
                                            autoComplete="off"
                                            id="pd-referral"
                                            value={referral || ""}
                                            placeholder="Referral details"
                                            onChange={(e) => setReferral(e.target.value)}
                                            onBlur={() => {
                                                if ((referral || "") !== (visitDetails?.referredBy || "")) handleReferralUpdate({ referredBy: referral || "" })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--district">
                                    <label htmlFor="pd-district" className="appointment-create-form__label">
                                        District
                                    </label>
                                    <div className="appointment-create-form__district w-100">
                                        <Select
                                            id="pd-district"
                                            style={{ width: "100%" }}
                                            showSearch
                                            placeholder="Select a district"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            value={
                                                seletedDistrict?.value
                                                    ? { label: seletedDistrict.label, value: seletedDistrict.value }
                                                    : undefined
                                            }
                                            options={districtList}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--address">
                                    <label htmlFor="pd-address" className="appointment-create-form__label appointment-create-form__label--top">
                                        Address
                                    </label>
                                    <textarea
                                        rows={2}
                                        id="pd-address"
                                        className="form-control input appointment-create-form__textarea"
                                        autoComplete="off"
                                        name="address"
                                        value={info?.address || ""}
                                        placeholder="Street, area, landmark"
                                        onChange={(e) => setInfoFun("address", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__panel">
                                <h3 className="appointment-create-form__section-title appointment-create-form__section-title--spaced">
                                    Demographics
                                </h3>
                                <div className="col-12 appointment-create-form__row">
                                    <label htmlFor="pd-blood" className="appointment-create-form__label">
                                        Blood group
                                    </label>
                                    <select
                                        id="pd-blood"
                                        className="appointment-create-form__control appointment-create-form__control--full"
                                        onChange={(e) => setAndSave("bloodGroup", e.target.value)}
                                        value={info?.bloodGroup || ""}
                                    >
                                        <option value="">Select</option>
                                        <option value="A+">A+</option>
                                        <option value="A-">A-</option>
                                        <option value="B+">B+</option>
                                        <option value="B-">B-</option>
                                        <option value="AB+">AB+</option>
                                        <option value="AB-">AB-</option>
                                        <option value="O+">O+</option>
                                        <option value="O-">O-</option>
                                    </select>
                                </div>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--radios">
                                    <span id="pd-gender-group" className="appointment-create-form__label">
                                        Gender<span className="text-danger">*</span>
                                    </span>
                                    <div
                                        role="group"
                                        aria-labelledby="pd-gender-group"
                                        className="appointment-create-form__radio-group"
                                    >
                                        <label className="appointment-create-form__radio">
                                            <input
                                                checked={info?.gender?.toLowerCase() === "male"}
                                                type="radio"
                                                name="gender"
                                                value="Male"
                                                required={!info?.gender?.length}
                                                onChange={() => setAndSave("gender", "Male")}
                                            />
                                            <span>Male</span>
                                        </label>
                                        <label className="appointment-create-form__radio">
                                            <input
                                                checked={info?.gender?.toLowerCase() === "female"}
                                                type="radio"
                                                name="gender"
                                                value="Female"
                                                required={!info?.gender?.length}
                                                onChange={() => setAndSave("gender", "Female")}
                                            />
                                            <span>Female</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 appointment-create-form__row">
                                    <label className="appointment-create-form__label">
                                        Marital status
                                    </label>
                                    <div className="w-100">
                                        <SelectWithLocalSearch
                                            currentValue={info?.maritalStatus}
                                            name="maritalStatus"
                                            handleFormValues={(status) => setAndSave("maritalStatus", status?.value)}
                                            isCreatable={false}
                                            options={maritalStatusOptions}
                                            placeHolder="Select marital status"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 appointment-create-form__row">
                                    <label className="appointment-create-form__label">
                                        Occupation
                                    </label>
                                    <div className="w-100">
                                        <SelectWithLocalSearch
                                            currentValue={occupationLabel}
                                            name="profession"
                                            handleFormValues={(profession) => setAndSave("profession", profession?.name)}
                                            isCreatable={true}
                                            handleCreate={handleCreateOccupation}
                                            options={occupationList}
                                            placeHolder="Select occupation"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__panel">
                                <h3 className="appointment-create-form__section-title appointment-create-form__section-title--spaced">
                                    Notes
                                </h3>
                                <div className="col-12 appointment-create-form__row appointment-create-form__row--address">
                                    <label htmlFor="pd-note" className="appointment-create-form__label appointment-create-form__label--top">
                                        Extra note
                                    </label>
                                    <textarea
                                        rows={3}
                                        id="pd-note"
                                        className="form-control input appointment-create-form__textarea"
                                        autoComplete="off"
                                        name="note"
                                        value={info?.note || ""}
                                        placeholder="Optional notes about the patient"
                                        onChange={(e) => setInfoFun("note", e.target.value)}
                                        onBlur={saveOnBlur}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            )}
        </Formik>
    );
};


export default PatientDemography
